import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "size-full overflow-y-auto scroll-smooth" };
const _hoisted_2 = { class: "pl-20 flex-1 overflow-hidden text-right whitespace-nowrap text-ellipsis" };
const _hoisted_3 = { class: "pl-20 flex-1 overflow-hidden text-right whitespace-nowrap text-ellipsis" };
const _hoisted_4 = { class: "flex-1 overflow-hidden text-right" };
const _hoisted_5 = { class: "flex-1 overflow-hidden text-right" };
const _hoisted_6 = { class: "flex-1 overflow-hidden text-right" };
import { computed } from 'vue';
import { FilterMenuType } from './home-filter-type';
import { useHomeFilterStore } from './homeFilterStore';
import { ChevronRight } from 'lucide-vue-next';
import HomeFilterDialogSelectedFilter from './home-filter-dialog-selected-filter.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-menu',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const brandSummary = computed(() => {
            const selectedBrands = homeFilterStore.selectedBrands;
            if (selectedBrands.length === 0) {
                return '';
            }
            if (selectedBrands.length >= 4) {
                return `Brand(${selectedBrands.length})`;
            }
            // For less than 4 brands, list them with commas
            return selectedBrands.map(brand => brand.name).join(', ');
        });
        const conditionSummary = computed(() => {
            const selectedConditions = homeFilterStore.selectedConditions;
            if (selectedConditions.length === 0) {
                return '';
            }
            if (selectedConditions.length >= 4) {
                return `Condition(${selectedConditions.length})`;
            }
            // For less than 4 conditions, list them with commas
            return selectedConditions.map(condition => condition.name).join(', ');
        });
        const priceSummary = computed(() => {
            const minPrice = homeFilterStore.minPrice;
            const maxPrice = homeFilterStore.maxPrice;
            if (minPrice === 0 && maxPrice === 0) {
                return '';
            }
            if (minPrice > 0 && maxPrice > 0) {
                return `$${minPrice.toLocaleString()} - $${maxPrice.toLocaleString()}`;
            }
            if (minPrice > 0) {
                return `From $${minPrice.toLocaleString()}`;
            }
            if (maxPrice > 0) {
                return `Up to $${maxPrice.toLocaleString()}`;
            }
            return '';
        });
        const yearSummary = computed(() => {
            const minYear = homeFilterStore.minYear;
            const maxYear = homeFilterStore.maxYear;
            if (minYear && maxYear) {
                return `${minYear} - ${maxYear}`;
            }
            if (minYear) {
                return `From ${minYear}`;
            }
            if (maxYear) {
                return `Up to ${maxYear}`;
            }
            return '';
        });
        const sizeSummary = computed(() => {
            const min = homeFilterStore.minSizeDiameter;
            const max = homeFilterStore.maxSizeDiameter;
            if (min === 0 && max === 0) {
                return '';
            }
            if (min > 0 && max > 0) {
                return `${min} - ${max} mm`;
            }
            if (min > 0) {
                return `From ${min} mm`;
            }
            if (max > 0) {
                return `Up to ${max} mm`;
            }
            return '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-badge mb-3 font-medium" }, "Selected filter(s)", -1)),
                _createVNode(HomeFilterDialogSelectedFilter),
                _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(homeFilterStore).changeMenu(_unref(FilterMenuType).BRAND))),
                    class: "w-full h-auto px-2 pt-6 pb-2 border-bottom border-line my-1 flex items-center"
                }, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-none h-full" }, "Brand", -1)),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(brandSummary.value), 1),
                    _createVNode(_unref(ChevronRight), { class: "flex-none size-6" })
                ]),
                _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event) => (_unref(homeFilterStore).changeMenu(_unref(FilterMenuType).CONDITION))),
                    class: "w-full h-auto px-2 pt-6 pb-2 border-bottom border-line my-1 flex items-center"
                }, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-none h-full" }, "Condition", -1)),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(conditionSummary.value), 1),
                    _createVNode(_unref(ChevronRight), { class: "flex-none size-6" })
                ]),
                _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ($event) => (_unref(homeFilterStore).changeMenu(_unref(FilterMenuType).PRICE))),
                    class: "w-full h-auto px-2 pt-6 pb-2 border-bottom border-line my-1 flex items-center"
                }, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-none h-full" }, "Price", -1)),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(priceSummary.value), 1),
                    _createVNode(_unref(ChevronRight), { class: "flex-none size-6" })
                ]),
                _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = ($event) => (_unref(homeFilterStore).changeMenu(_unref(FilterMenuType).YEAR))),
                    class: "w-full h-auto px-2 pt-6 pb-2 border-bottom border-line my-1 flex items-center"
                }, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-none h-full" }, "Year", -1)),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(yearSummary.value), 1),
                    _createVNode(_unref(ChevronRight), { class: "flex-none size-6" })
                ]),
                _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = ($event) => (_unref(homeFilterStore).changeMenu(_unref(FilterMenuType).SIZE))),
                    class: "w-full h-auto px-2 pt-6 pb-2 border-bottom border-line my-1 flex items-center"
                }, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-none h-full" }, "Case size", -1)),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(sizeSummary.value), 1),
                    _createVNode(_unref(ChevronRight), { class: "flex-none size-6" })
                ])
            ]));
        };
    }
});
